import { render } from "./CalendarHeader.vue?vue&type=template&id=c0c3aec4&scoped=true"
import script from "./CalendarHeader.vue?vue&type=script&lang=js"
export * from "./CalendarHeader.vue?vue&type=script&lang=js"

import "./CalendarHeader.vue?vue&type=style&index=0&id=c0c3aec4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0c3aec4"]])

export default __exports__